import { render, staticRenderFns } from "./GetFile.vue?vue&type=template&id=849d43b0"
import script from "./GetFile.vue?vue&type=script&lang=js"
export * from "./GetFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports